import { Box, Heading, ListItem, UnorderedList } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import ConversationArea, { NO_TOPIC_STRING } from '../../classes/ConversationArea';
import Player from '../../classes/Player';
import useConversationAreas from '../../hooks/useConversationAreas';
import usePlayersInTown from '../../hooks/usePlayersInTown';
import PlayerName from './PlayerName';

/**
 * ConversationAreaComponentProps are the props of ConversationAreaComponent
 */
 interface ConversationAreaComponentProps {
  conversationArea: ConversationArea,
  playersInTown: Player[]
}

/**
 * Creates a ConversationAreaComponent
 * @param props from ConversationAreaComponentProps 
 * @returns the component
 */
function ConversationAreaComponent({conversationArea, playersInTown}: ConversationAreaComponentProps): JSX.Element {
  const [occupants, setOccupants] = useState<string[]>(conversationArea.occupants);

  const getPlayerByID = (id : string): Player => {
    let player;
    playersInTown.forEach((playerInTown) => {if (playerInTown.id === id) {player = playerInTown}});
    if (player) {
      return player;
    }
    throw new Error("Player ID not present");
  };
  useEffect(() => {
    const conversationAreaListener = {onOccupantsChange: setOccupants};
    conversationArea.addListener(conversationAreaListener);
    return () => {
      conversationArea.removeListener(conversationAreaListener);
    };
  }, [conversationArea, setOccupants]);
  
  return <Box>
    <Heading as='h3'>{conversationArea.label}: {conversationArea.topic}</Heading>
    <UnorderedList>
      {occupants.map((playerID) => <ListItem key={playerID}><PlayerName player={getPlayerByID(playerID)}/></ListItem>)}
    </UnorderedList>
  </Box>
}

export default function ConversationAreasList(): JSX.Element {
  const conversationAreas = useConversationAreas();
  const playersInTown = usePlayersInTown();

  const activeConversationAreas = conversationAreas.filter((conversationArea) => conversationArea.topic !== NO_TOPIC_STRING);
  const sortedConversationAreas = activeConversationAreas.sort((a, b) => a.label.localeCompare(b.label, 'en', {numeric: true}));

  if (sortedConversationAreas.length === 1) {
    return <> <ConversationAreaComponent conversationArea={sortedConversationAreas[0]} playersInTown={playersInTown} /> </>;
  }
  if(sortedConversationAreas.length > 0) {
      return <>{sortedConversationAreas.map((conversationArea) => <ConversationAreaComponent key={conversationArea.label} conversationArea={conversationArea} playersInTown={playersInTown}/>)}</>
  }
  // console.log("No conversation areas");
  return <Box><Heading as='h2'>No active conversation areas</Heading></Box>;
}